"use strict";
/*
 * Created on 04 30 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../../core/utils/index");

var SelloutImpactReportDetailValuesDTO_1 = require("../model/SelloutImpactReportDetailValuesDTO");

var SelloutImpactReportDetailValuesDTOConverter_1 = require("./SelloutImpactReportDetailValuesDTOConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailValuesDTOConverterImpl =
/*#__PURE__*/
function (_SelloutImpactReportD) {
  _inherits(SelloutImpactReportDetailValuesDTOConverterImpl, _SelloutImpactReportD);

  function SelloutImpactReportDetailValuesDTOConverterImpl() {
    _classCallCheck(this, SelloutImpactReportDetailValuesDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailValuesDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutImpactReportDetailValuesDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SelloutImpactReportDetailValuesDTO_1.SelloutImpactReportDetailValuesDTO(conversions.toBigNumber(source.salesVolume), conversions.asObjectOpt(source, 'salesVolumeSellout', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'salesVolumeActual', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'salesVolumeImpact', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'salesVolumeImpactPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'salesVolumeForecastDelta', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'salesVolumeForecastDeltaPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'salesVolumeFA', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'salesVolumeFAPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.toBigNumber(source.revenue), conversions.asObjectOpt(source, 'revenueSellout', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'revenueActual', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'revenueImpact', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'revenueImpactPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'revenueForecastDelta', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'revenueForecastDeltaPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'revenueFA', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'revenueFAPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.toBigNumber(source.profit), conversions.asObjectOpt(source, 'profitSellout', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitActual', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitImpact', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitImpactPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitForecastDelta', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitForecastDeltaPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitFA', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'profitFAPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.toBigNumber(source.margin), conversions.asObjectOpt(source, 'marginSellout', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginActual', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginImpact', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginImpactPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginForecastDelta', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginForecastDeltaPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginFA', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'marginFAPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'initialStockVolume', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'stockVolume', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'stockVolumeDelta', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'stockVolumeDeltaPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'initialStockValue', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'stockValue', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'stockValueDelta', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'stockValueDeltaPercents', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'faPercents', function (v) {
        return conversions.toBigNumber(v);
      }), index_1.Utils.asNumber(source.realDays));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        salesVolume: conversions.fromBigNumber(source.salesVolume),
        salesVolumeSellout: conversions.asObjectOpt(source, 'salesVolumeSellout', function (v) {
          return conversions.fromBigNumber(v);
        }),
        salesVolumeActual: conversions.asObjectOpt(source, 'salesVolumeActual', function (v) {
          return conversions.fromBigNumber(v);
        }),
        salesVolumeImpact: conversions.asObjectOpt(source, 'salesVolumeImpact', function (v) {
          return conversions.fromBigNumber(v);
        }),
        salesVolumeImpactPercents: conversions.asObjectOpt(source, 'salesVolumeImpactPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        salesVolumeForecastDelta: conversions.asObjectOpt(source, 'salesVolumeForecastDelta', function (v) {
          return conversions.fromBigNumber(v);
        }),
        salesVolumeForecastDeltaPercents: conversions.asObjectOpt(source, 'salesVolumeForecastDeltaPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        salesVolumeFA: conversions.asObjectOpt(source, 'salesVolumeFA', function (v) {
          return conversions.fromBigNumber(v);
        }),
        salesVolumeFAPercents: conversions.asObjectOpt(source, 'salesVolumeFAPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenue: conversions.fromBigNumber(source.revenue),
        revenueSellout: conversions.asObjectOpt(source, 'revenueSellout', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenueActual: conversions.asObjectOpt(source, 'revenueActual', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenueImpact: conversions.asObjectOpt(source, 'revenueImpact', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenueImpactPercents: conversions.asObjectOpt(source, 'revenueImpactPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenueForecastDelta: conversions.asObjectOpt(source, 'revenueForecastDelta', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenueForecastDeltaPercents: conversions.asObjectOpt(source, 'revenueForecastDeltaPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenueFA: conversions.asObjectOpt(source, 'revenueFA', function (v) {
          return conversions.fromBigNumber(v);
        }),
        revenueFAPercents: conversions.asObjectOpt(source, 'revenueFAPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profit: conversions.fromBigNumber(source.profit),
        profitSellout: conversions.asObjectOpt(source, 'profitSellout', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profitActual: conversions.asObjectOpt(source, 'profitActual', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profitImpact: conversions.asObjectOpt(source, 'profitImpact', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profitImpactPercents: conversions.asObjectOpt(source, 'profitImpactPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profitForecastDelta: conversions.asObjectOpt(source, 'profitForecastDelta', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profitForecastDeltaPercents: conversions.asObjectOpt(source, 'profitForecastDeltaPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profitFA: conversions.asObjectOpt(source, 'profitFA', function (v) {
          return conversions.fromBigNumber(v);
        }),
        profitFAPercents: conversions.asObjectOpt(source, 'profitFAPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        margin: conversions.fromBigNumber(source.margin),
        marginSellout: conversions.asObjectOpt(source, 'marginSellout', function (v) {
          return conversions.fromBigNumber(v);
        }),
        marginActual: conversions.asObjectOpt(source, 'marginActual', function (v) {
          return conversions.fromBigNumber(v);
        }),
        marginImpact: conversions.asObjectOpt(source, 'marginImpact', function (v) {
          return conversions.fromBigNumber(v);
        }),
        marginImpactPercents: conversions.asObjectOpt(source, 'marginImpactPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        marginForecastDelta: conversions.asObjectOpt(source, 'marginForecastDelta', function (v) {
          return conversions.fromBigNumber(v);
        }),
        marginForecastDeltaPercents: conversions.asObjectOpt(source, 'marginForecastDeltaPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        marginFA: conversions.asObjectOpt(source, 'marginFA', function (v) {
          return conversions.fromBigNumber(v);
        }),
        marginFAPercents: conversions.asObjectOpt(source, 'marginFAPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        initialStockVolume: conversions.asObjectOpt(source, 'initialStockVolume', function (v) {
          return conversions.fromBigNumber(v);
        }),
        stockVolume: conversions.asObjectOpt(source, 'stockVolume', function (v) {
          return conversions.fromBigNumber(v);
        }),
        stockVolumeDelta: conversions.asObjectOpt(source, 'stockVolumeDelta', function (v) {
          return conversions.fromBigNumber(v);
        }),
        stockVolumeDeltaPercents: conversions.asObjectOpt(source, 'stockVolumeDeltaPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        initialStockValue: conversions.asObjectOpt(source, 'initialStockValue', function (v) {
          return conversions.fromBigNumber(v);
        }),
        stockValue: conversions.asObjectOpt(source, 'stockValue', function (v) {
          return conversions.fromBigNumber(v);
        }),
        stockValueDelta: conversions.asObjectOpt(source, 'stockValueDelta', function (v) {
          return conversions.fromBigNumber(v);
        }),
        stockValueDeltaPercents: conversions.asObjectOpt(source, 'stockValueDeltaPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        faPercents: conversions.asObjectOpt(source, 'faPercents', function (v) {
          return conversions.fromBigNumber(v);
        }),
        realDays: source.realDays
      };
    }
  }]);

  return SelloutImpactReportDetailValuesDTOConverterImpl;
}(SelloutImpactReportDetailValuesDTOConverter_1.SelloutImpactReportDetailValuesDTOConverter);

exports.SelloutImpactReportDetailValuesDTOConverterImpl = SelloutImpactReportDetailValuesDTOConverterImpl;